// AUTO-GENERATED by scripts/generate-responsive-image-manifest.ts — do not edit by hand.
// Regenerate with: pnpm generate:image-manifest
//
// Welche `-<width>w` Varianten jedes Quellbild wirklich hat. Ohne diese Liste
// raten die Bildkomponenten, und ein geratener `srcset`-Kandidat, den es nicht
// gibt, laesst das Bild leer — `srcset` faellt bei 404 nicht auf `src` zurueck.
//
// Der Schluessel ist der Bildpfad samt angefragtem Format, der Wert die
// aufsteigend sortierten verfuegbaren Breiten. Fehlt ein Pfad, gibt es keine
// Varianten: dann wird gar kein `srcset` gesetzt und der Browser nimmt `src`.

export const RESPONSIVE_IMAGE_VARIANTS: Readonly<Record<string, readonly number[]>> = {
    "/images/blog/authors/christian.webp": [24, 32, 40, 48, 60, 64, 80, 96, 100, 120, 128, 160],
    "/images/blog/authors/jan.webp": [24, 32, 40, 48, 64, 80, 96, 120, 128, 160],
    "/images/blog/authors/michael.webp": [24, 32, 40, 48, 64, 80, 96, 120, 128, 160],
    "/images/blog/authors/monika-jud.webp": [24, 32, 40, 48, 64, 80, 96, 120, 128],
    "/images/blog/authors/patrick-fehr.webp": [24, 32, 40, 48, 64, 80, 96, 120, 128],
    "/images/blog/authors/sibylle-ambs.webp": [24, 32, 40, 48, 60, 64, 80, 96, 100, 120, 128, 160],
    "/images/blog/building-blocks-for-your-website/webbloqs-katalog.jpg": [320, 640, 960],
    "/images/blog/building-blocks-for-your-website/webbloqs-katalog.webp": [320, 640, 960],
    "/images/blog/building-blocks-for-your-website/webbloqs-logo.webp": [640, 960, 1280],
    "/images/blog/business-driven-application-development/bdad-illustration.webp": [640, 960, 1280],
    "/images/blog/business-driven-application-development/bdad.webp": [640, 960, 1280],
    "/images/blog/code-retreat/Abendspaziergang.webp": [320, 640, 960, 1280, 1920],
    "/images/blog/code-retreat/code-retreat-hero.webp": [960, 1280, 1920],
    "/images/blog/code-retreat/Code-Retreat.webp": [320, 640, 960, 1280, 1920],
    "/images/blog/code-retreat/Event-Storming.webp": [320, 640, 960, 1280, 1920],
    "/images/blog/code-retreat/Feier.webp": [320, 640, 960, 1280, 1920],
    "/images/blog/code-retreat/Patrick_isst_einen_kleinen_Taco.webp": [320],
    "/images/blog/code-retreat/qHackaton-Amden.webp": [640, 960, 1280],
    "/images/blog/code-retreat/screenshot_backoffice.webp": [320, 640, 960, 1280],
    "/images/blog/code-retreat/screenshot_fomular_offertenanfrage.webp": [320, 640, 960, 1280],
    "/images/blog/code-retreat/teaser_Code-Retreat.webp": [320, 640, 960, 1280, 1920],
    "/images/blog/code-retreat/Workshop.webp": [320, 640, 960, 1280, 1920],
    "/images/blog/heading-inspector/screenshot-1.jpg": [320, 640, 960, 1280],
    "/images/blog/heading-inspector/screenshot-1.webp": [320, 640, 960, 1280],
    "/images/blog/heading-inspector/screenshot-2.jpg": [320, 640, 960, 1280],
    "/images/blog/heading-inspector/screenshot-2.webp": [320, 640, 960, 1280],
    "/images/blog/lean-poker-bots-all-in/quatico-bot.webp": [640, 960, 1280, 1920],
    "/images/blog/meteoschweiz-best-of-swiss-web-2023/siegerfoto.webp": [640, 960, 1280],
    "/images/blog/quality-time-snow-weekend/bergfahrt.webp": [640, 960, 1280, 1920],
    "/images/blog/spannung-spass-spiel-simmental/gipfelkreuz.webp": [640, 960, 1280],
    "/images/blog/spannung-spass-spiel-simmental/simmental-mystisch.webp": [640, 960, 1280, 1920],
    "/images/community/hackergarten.jpg": [320],
    "/images/community/hackergarten.webp": [320],
    "/images/community/jug.jpg": [320, 640],
    "/images/community/jug.webp": [320, 640],
    "/images/community/socrates.jpg": [320],
    "/images/community/socrates.webp": [320],
    "/images/community/swiss-made-software.jpg": [320, 640],
    "/images/community/swiss-made-software.webp": [320, 640],
    "/images/customers/adobe.jpg": [320, 640],
    "/images/customers/adobe.webp": [320, 640],
    "/images/customers/amag.jpg": [320, 640],
    "/images/customers/amag.webp": [320, 640],
    "/images/customers/appway.jpg": [320, 640],
    "/images/customers/appway.webp": [320, 640],
    "/images/customers/basel-stadt.jpg": [320, 640],
    "/images/customers/basel-stadt.webp": [320, 640],
    "/images/customers/bfh.jpg": [320, 640],
    "/images/customers/bfh.webp": [320, 640],
    "/images/customers/bund.jpg": [320, 640],
    "/images/customers/bund.webp": [320, 640],
    "/images/customers/credit-suisse.jpg": [320, 640],
    "/images/customers/credit-suisse.webp": [320, 640],
    "/images/customers/ekz.jpg": [320, 640],
    "/images/customers/ekz.webp": [320, 640],
    "/images/customers/eth.jpg": [320, 640],
    "/images/customers/eth.webp": [320, 640],
    "/images/customers/ewz.jpg": [320, 640],
    "/images/customers/ewz.webp": [320, 640],
    "/images/customers/far.jpg": [320, 640],
    "/images/customers/far.webp": [320, 640],
    "/images/customers/helsana.jpg": [320, 640],
    "/images/customers/helsana.webp": [320, 640],
    "/images/customers/kanton-aargau.jpg": [320, 640],
    "/images/customers/kanton-aargau.webp": [320, 640],
    "/images/customers/lipo.jpg": [320, 640],
    "/images/customers/lipo.webp": [320, 640],
    "/images/customers/mieterverband.jpg": [320, 640],
    "/images/customers/mieterverband.webp": [320, 640],
    "/images/customers/sanitas.jpg": [320, 640],
    "/images/customers/sanitas.webp": [320, 640],
    "/images/customers/sbb.jpg": [320, 640],
    "/images/customers/sbb.webp": [320, 640],
    "/images/customers/schuetzengarten.jpg": [320, 640],
    "/images/customers/schuetzengarten.webp": [320, 640],
    "/images/customers/six-group.jpg": [320, 640],
    "/images/customers/six-group.webp": [320, 640],
    "/images/customers/stadt-zuerich.jpg": [320, 640],
    "/images/customers/stadt-zuerich.webp": [320, 640],
    "/images/customers/straumann.jpg": [320, 640],
    "/images/customers/straumann.webp": [320, 640],
    "/images/customers/unia.jpg": [320, 640],
    "/images/customers/unia.webp": [320, 640],
    "/images/customers/upc.jpg": [320, 640],
    "/images/customers/upc.webp": [320, 640],
    "/images/customers/wvz.jpg": [320, 640],
    "/images/customers/wvz.webp": [320, 640],
    "/images/icons/icon-512x512.jpg": [320],
    "/images/icons/icon-512x512.webp": [320],
    "/images/illustrations/cds-platform.jpg": [320, 640, 960],
    "/images/illustrations/cds-platform.webp": [320, 640, 960],
    "/images/illustrations/cds-section.jpg": [320],
    "/images/illustrations/cds-section.webp": [320],
    "/images/illustrations/ewz-laptop.jpg": [320, 640, 960, 1280],
    "/images/illustrations/ewz-laptop.webp": [320, 640, 960, 1280],
    "/images/illustrations/hero-ki-agenten-workshop.webp": [320, 640, 960, 1280, 1920],
    "/images/illustrations/hero-ki-potenzialanalyse.jpg": [320, 640, 960, 1280, 1920],
    "/images/illustrations/hero-ki-potenzialanalyse.webp": [320, 640, 960, 1280, 1920],
    "/images/illustrations/hero-platform.jpg": [320, 640, 960],
    "/images/illustrations/hero-platform.webp": [320, 640, 960],
    "/images/illustrations/main-functions/cloud-1x.jpg": [320],
    "/images/illustrations/main-functions/cloud-1x.webp": [320],
    "/images/illustrations/main-functions/cloud-2x.jpg": [320, 640],
    "/images/illustrations/main-functions/cloud-2x.webp": [320, 640],
    "/images/illustrations/main-functions/connectors-1x.jpg": [320],
    "/images/illustrations/main-functions/connectors-1x.webp": [320],
    "/images/illustrations/main-functions/connectors-2x.jpg": [320, 640, 960],
    "/images/illustrations/main-functions/connectors-2x.webp": [320, 640, 960],
    "/images/illustrations/main-functions/delegate-access-1x.jpg": [320],
    "/images/illustrations/main-functions/delegate-access-1x.webp": [320],
    "/images/illustrations/main-functions/delegate-access-2x.jpg": [320, 640],
    "/images/illustrations/main-functions/delegate-access-2x.webp": [320, 640],
    "/images/illustrations/main-functions/manage-applications-1x.jpg": [320],
    "/images/illustrations/main-functions/manage-applications-1x.webp": [320],
    "/images/illustrations/main-functions/manage-applications-2x.jpg": [320, 640, 960],
    "/images/illustrations/main-functions/manage-applications-2x.webp": [320, 640, 960],
    "/images/illustrations/main-functions/visual-configuration-1x.jpg": [320],
    "/images/illustrations/main-functions/visual-configuration-1x.webp": [320],
    "/images/illustrations/main-functions/visual-configuration-2x.jpg": [320, 640, 960],
    "/images/illustrations/main-functions/visual-configuration-2x.webp": [320, 640, 960],
    "/images/illustrations/solution-1-vertrieb.jpg": [320, 640],
    "/images/illustrations/solution-1-vertrieb.webp": [320, 640],
    "/images/illustrations/solution-2-kundendienst.jpg": [320, 640],
    "/images/illustrations/solution-2-kundendienst.webp": [320, 640],
    "/images/illustrations/solution-3-portal.jpg": [320, 640],
    "/images/illustrations/solution-3-portal.webp": [320, 640],
    "/images/illustrations/solution-4-individualisierung.jpg": [320, 640],
    "/images/illustrations/solution-4-individualisierung.webp": [320, 640],
    "/images/illustrations/solution-5-integration.jpg": [320, 640, 960],
    "/images/illustrations/solution-5-integration.webp": [320, 640, 960],
    "/images/illustrations/teaser-platform.jpg": [320, 640, 960, 1280, 1920],
    "/images/illustrations/teaser-platform.webp": [320, 640, 960, 1280, 1920],
    "/images/illustrations/value-proposition/central-management-1x.jpg": [320],
    "/images/illustrations/value-proposition/central-management-1x.webp": [320],
    "/images/illustrations/value-proposition/central-management-2x.jpg": [320, 640],
    "/images/illustrations/value-proposition/central-management-2x.webp": [320, 640],
    "/images/illustrations/value-proposition/faster-digitalization-1x.jpg": [320],
    "/images/illustrations/value-proposition/faster-digitalization-1x.webp": [320],
    "/images/illustrations/value-proposition/faster-digitalization-2x.jpg": [320, 640],
    "/images/illustrations/value-proposition/faster-digitalization-2x.webp": [320, 640],
    "/images/illustrations/value-proposition/unified-user-experience-1x.jpg": [320],
    "/images/illustrations/value-proposition/unified-user-experience-1x.webp": [320],
    "/images/illustrations/value-proposition/unified-user-experience-2x.jpg": [320, 640],
    "/images/illustrations/value-proposition/unified-user-experience-2x.webp": [320, 640],
    "/images/illustrations/value-props.jpg": [320, 640],
    "/images/illustrations/value-props.webp": [320, 640],
    "/images/illustrations/workshop-domaenenkarte.jpg": [320, 640, 960],
    "/images/illustrations/workshop-domaenenkarte.webp": [320, 640, 960],
    "/images/illustrations/workshop-domain-storytelling.jpg": [320, 640, 960],
    "/images/illustrations/workshop-domain-storytelling.webp": [320, 640, 960],
    "/images/illustrations/workshop-event-storming.jpg": [320, 640, 960],
    "/images/illustrations/workshop-event-storming.webp": [320, 640, 960],
    "/images/illustrations/workshop-governance.jpg": [320, 640, 960],
    "/images/illustrations/workshop-governance.webp": [320, 640, 960],
    "/images/illustrations/workshop-impact-mapping.jpg": [320, 640, 960],
    "/images/illustrations/workshop-impact-mapping.webp": [320, 640, 960],
    "/images/illustrations/workshop-kontextlandkarte.jpg": [320, 640, 960],
    "/images/illustrations/workshop-kontextlandkarte.webp": [320, 640, 960],
    "/images/illustrations/workshop-value-stream-mapping.jpg": [320, 640, 960],
    "/images/illustrations/workshop-value-stream-mapping.webp": [320, 640, 960],
    "/images/jobs/executive-assistant-at-work.jpg": [320, 640, 960, 1280, 1920],
    "/images/jobs/executive-assistant-at-work.webp": [320, 640, 960, 1280, 1920],
    "/images/offert-generator/offert-generator_1x.webp": [320, 640],
    "/images/offert-generator/offert-generator.webp": [320, 640],
    "/images/screenshots/ewz-screenshot.jpg": [320],
    "/images/screenshots/ewz-screenshot.webp": [320],
    "/images/screenshots/far-screenshot.jpg": [320],
    "/images/screenshots/far-screenshot.webp": [320],
    "/images/screenshots/meteoschweiz-screenshot.jpg": [320],
    "/images/screenshots/meteoschweiz-screenshot.webp": [320],
    "/images/sections/hero-background.jpg": [320, 640, 960, 1280],
    "/images/sections/hero-background.webp": [320, 640, 960, 1280],
    "/images/service-catalog/badge-showroom.jpg": [320, 640],
    "/images/service-catalog/badge-showroom.webp": [320, 640],
    "/images/success-stories/ewz-fernwaerme-fit/ewz-fernwaerme-success.jpg": [320, 640, 960, 1280, 1920],
    "/images/success-stories/ewz-fernwaerme-fit/ewz-fernwaerme-success.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/ewz-kundenportal/b2c-portal.jpg": [320, 640, 960, 1280],
    "/images/success-stories/ewz-kundenportal/b2c-portal.webp": [320, 640, 960, 1280],
    "/images/success-stories/ewz-kundenportal/ewz-kundenportal-screenshot.jpg": [320, 640, 960, 1280, 1920],
    "/images/success-stories/ewz-kundenportal/ewz-kundenportal-screenshot.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/ewz-kundenportal/ewz-success.jpg": [320, 640, 960],
    "/images/success-stories/ewz-kundenportal/ewz-success.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/ewz-kundenportal/verbrauchsdaten.jpg": [320, 640, 960, 1280, 1920],
    "/images/success-stories/ewz-kundenportal/verbrauchsdaten.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/far-geschaeftsprozesse/dashboard.2x.jpg": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/dashboard.2x.webp": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/far-success.jpg": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/far-success.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/far-geschaeftsprozesse/maske-dossier-erstellen.2x.jpg": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/maske-dossier-erstellen.2x.webp": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/prozess-rentengesuch.2x.jpg": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/prozess-rentengesuch.2x.webp": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/serienbriefe-exportieren.2x.jpg": [320, 640, 960, 1280],
    "/images/success-stories/far-geschaeftsprozesse/serienbriefe-exportieren.2x.webp": [320, 640, 960, 1280],
    "/images/success-stories/liechtensteinische-post-retourenmanagement/liechtensteinische-post-success.jpg": [
        320, 640, 960, 1280, 1920,
    ],
    "/images/success-stories/liechtensteinische-post-retourenmanagement/liechtensteinische-post-success.webp": [
        320, 640, 960, 1280, 1920,
    ],
    "/images/success-stories/meteoschweiz-webportal/gefahren-und-wetterkarten.jpg": [320, 640, 960, 1280],
    "/images/success-stories/meteoschweiz-webportal/gefahren-und-wetterkarten.webp": [320, 640, 960, 1280],
    "/images/success-stories/meteoschweiz-webportal/lokalprognose.jpg": [320, 640],
    "/images/success-stories/meteoschweiz-webportal/lokalprognose.webp": [320, 640],
    "/images/success-stories/meteoschweiz-webportal/messwerte.jpg": [320],
    "/images/success-stories/meteoschweiz-webportal/messwerte.webp": [320],
    "/images/success-stories/meteoschweiz-webportal/meteoschweiz-success.jpg": [320, 640, 960],
    "/images/success-stories/meteoschweiz-webportal/meteoschweiz-success.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/meteoschweiz-webportal/tacho-und-messwerte.jpg": [320, 640, 960, 1280],
    "/images/success-stories/meteoschweiz-webportal/tacho-und-messwerte.webp": [320, 640, 960, 1280],
    "/images/success-stories/meteoschweiz-webportal/tacho.jpg": [320],
    "/images/success-stories/meteoschweiz-webportal/tacho.webp": [320],
    "/images/success-stories/meteoschweiz-webportal/uebersicht-wetterkarten.jpg": [320],
    "/images/success-stories/meteoschweiz-webportal/uebersicht-wetterkarten.webp": [320],
    "/images/success-stories/naturgefahrenportal/naturgefahrenportal-success.jpg": [320, 640, 960, 1280, 1920],
    "/images/success-stories/naturgefahrenportal/naturgefahrenportal-success.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/wvz-kundenportal/verbrauchsdaten.jpg": [320, 640, 960, 1280, 1920],
    "/images/success-stories/wvz-kundenportal/verbrauchsdaten.webp": [320, 640, 960, 1280, 1920],
    "/images/success-stories/wvz-kundenportal/wvz-success.jpg": [320, 640, 960, 1280, 1920],
    "/images/success-stories/wvz-kundenportal/wvz-success.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/best-of-swiss-web-2023.jpg": [320, 640],
    "/images/team-events/best-of-swiss-web-2023.webp": [320, 640],
    "/images/team-events/bosw23/BoSW-super-heroes.jpg": [320, 640, 960],
    "/images/team-events/bosw23/BoSW-super-heroes.webp": [320, 640, 960],
    "/images/team-events/bosw23/siegerfoto.jpg": [320, 640, 960, 1280],
    "/images/team-events/bosw23/siegerfoto.webp": [320, 640, 960, 1280],
    "/images/team-events/collage-quatico-at-work.jpg": [320, 640, 960],
    "/images/team-events/collage-quatico-at-work.webp": [320, 640, 960],
    "/images/team-events/collage-team-events.jpg": [320, 640, 960],
    "/images/team-events/collage-team-events.webp": [320, 640, 960],
    "/images/team-events/lean-poker/all-teams.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/lean-poker/all-teams.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/lean-poker/debriefing.jpg": [320, 640, 960],
    "/images/team-events/lean-poker/debriefing.webp": [320, 640, 960],
    "/images/team-events/lean-poker/quatico-bot.jpg": [320, 640, 960, 1280],
    "/images/team-events/lean-poker/quatico-bot.webp": [320, 640, 960, 1280],
    "/images/team-events/lean-poker/team-big-blind.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/lean-poker/team-big-blind.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/lean-poker/team-deepBlueGoesVegas.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/lean-poker/team-deepBlueGoesVegas.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/lean-poker/team-pokerface.jpg": [320, 640, 960],
    "/images/team-events/lean-poker/team-pokerface.webp": [320, 640, 960],
    "/images/team-events/lean-poker/team-replicants.jpg": [320, 640, 960],
    "/images/team-events/lean-poker/team-replicants.webp": [320, 640, 960],
    "/images/team-events/microtasks/workshopFoxtrailFinisher.jpg": [320],
    "/images/team-events/microtasks/workshopFoxtrailFinisher.webp": [320],
    "/images/team-events/office.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/office.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qHackathon/Abendspaziergang.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qHackathon/Abendspaziergang.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qHackathon/Feier.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qHackathon/Feier.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qHackathon/Patrick_isst_einen_kleinen_Taco.jpg": [320],
    "/images/team-events/qHackathon/Patrick_isst_einen_kleinen_Taco.webp": [320],
    "/images/team-events/qHackathon/Workshop.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qHackathon/Workshop.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/apero.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/apero.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/aussenKlo.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/aussenKlo.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/bergfahrt.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/bergfahrt.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/billard.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/billard.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/essgespraech.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/essgespraech.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/gleitschirm.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/gleitschirm.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/langlauf.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/langlauf.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/mosiBar.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/mosiBar.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/nebelmeer.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/nebelmeer.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/schneeschuhWanderung.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/schneeschuhWanderung.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/schneesportler.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/schneesportler.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/sessellift.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/sessellift.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/sonnenbaden.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/sonnenbaden.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/stoosBahn.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/stoosBahn.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/stoosLodge.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/stoosLodge.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/teaserSnowWeekend.jpg": [320, 640, 960],
    "/images/team-events/qSnowWeekend/teaserSnowWeekend.webp": [320, 640, 960],
    "/images/team-events/qSnowWeekend/waldhuettli.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/qSnowWeekend/waldhuettli.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/wanderwochenende-2022/alprundweg-leiterli.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/alprundweg-leiterli.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/gipfelbier.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/gipfelbier.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/gipfelkreuz.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/gipfelkreuz.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/gipfelstuermer.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/gipfelstuermer.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/grotte.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/grotte.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/im-wildbach.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/im-wildbach.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/klettersteig.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/klettersteig.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/pizza.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/wanderwochenende-2022/pizza.webp": [320, 640, 960, 1280, 1920],
    "/images/team-events/wanderwochenende-2022/teamhaus.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/teamhaus.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/teaserGipfelkreuz.jpg": [320, 640],
    "/images/team-events/wanderwochenende-2022/teaserGipfelkreuz.webp": [320, 640],
    "/images/team-events/wanderwochenende-2022/teaserSimmental.jpg": [320, 640],
    "/images/team-events/wanderwochenende-2022/teaserSimmental.webp": [320, 640],
    "/images/team-events/wanderwochenende-2022/teaserWandergruppe.jpg": [320, 640],
    "/images/team-events/wanderwochenende-2022/teaserWandergruppe.webp": [320, 640],
    "/images/team-events/wanderwochenende-2022/tischtennis.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/tischtennis.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/trotti-abfahrt.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/trotti-abfahrt.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/trotti-start.jpg": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/trotti-start.webp": [320, 640, 960],
    "/images/team-events/wanderwochenende-2022/wandergruppe-im-schnee.jpg": [320, 640, 960, 1280, 1920],
    "/images/team-events/wanderwochenende-2022/wandergruppe-im-schnee.webp": [320, 640, 960, 1280, 1920],
    "/images/team/jan.jpg": [320],
    "/images/team/jan.webp": [320],
    "/images/team/michael.jpg": [320],
    "/images/team/michael.webp": [320],
    "/images/team/partners/portrait-christian.jpg": [320, 640],
    "/images/team/partners/portrait-christian.webp": [320, 640],
    "/images/team/partners/portrait-jan.jpg": [320, 640],
    "/images/team/partners/portrait-jan.webp": [320, 640],
    "/images/team/partners/portrait-max.jpg": [320, 640],
    "/images/team/partners/portrait-max.webp": [320, 640],
    "/images/team/partners/portrait-michael.jpg": [320, 640],
    "/images/team/partners/portrait-michael.webp": [320, 640],
    "/images/team/partners/portrait-ralph.jpg": [320, 640],
    "/images/team/partners/portrait-ralph.webp": [320, 640],
    "/images/team/roles/value-experimentieren-lernen.jpg": [320, 640, 960],
    "/images/team/roles/value-experimentieren-lernen.webp": [320, 640, 960],
    "/images/team/roles/value-grossartig-machen.jpg": [320, 640, 960],
    "/images/team/roles/value-grossartig-machen.webp": [320, 640, 960],
    "/images/team/roles/value-kontinulierlich-wert-liefern.jpg": [320, 640, 960],
    "/images/team/roles/value-kontinulierlich-wert-liefern.webp": [320, 640, 960],
    "/images/team/roles/value-sicherheit.jpg": [320, 640, 960],
    "/images/team/roles/value-sicherheit.webp": [320, 640, 960],
    "/images/vp-overview/VpOverviewHero_1x.jpg": [320, 640, 960, 1280],
    "/images/vp-overview/VpOverviewHero_1x.webp": [320, 640, 960, 1280],
    "/images/vp-overview/VpOverviewHero_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-overview/VpOverviewHero_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/animation_1_1x.jpg": [320],
    "/images/vp-starter/animation_1_1x.webp": [320],
    "/images/vp-starter/animation_1_2x.jpg": [320, 640, 960],
    "/images/vp-starter/animation_1_2x.webp": [320, 640, 960],
    "/images/vp-starter/animation_2_1x.jpg": [320],
    "/images/vp-starter/animation_2_1x.webp": [320],
    "/images/vp-starter/animation_2_2x.jpg": [320, 640, 960],
    "/images/vp-starter/animation_2_2x.webp": [320, 640, 960],
    "/images/vp-starter/animation_3_1x.jpg": [320],
    "/images/vp-starter/animation_3_1x.webp": [320],
    "/images/vp-starter/animation_3_2x.jpg": [320, 640, 960],
    "/images/vp-starter/animation_3_2x.webp": [320, 640, 960],
    "/images/vp-starter/animation_4_1x.jpg": [320],
    "/images/vp-starter/animation_4_1x.webp": [320],
    "/images/vp-starter/animation_4_2x.jpg": [320, 640, 960],
    "/images/vp-starter/animation_4_2x.webp": [320, 640, 960],
    "/images/vp-starter/animation_5_1x.jpg": [320],
    "/images/vp-starter/animation_5_1x.webp": [320],
    "/images/vp-starter/animation_5_2x.jpg": [320, 640, 960],
    "/images/vp-starter/animation_5_2x.webp": [320, 640, 960],
    "/images/vp-starter/features/angebotseditor.jpg": [320, 640, 960],
    "/images/vp-starter/features/angebotseditor.webp": [320, 640, 960],
    "/images/vp-starter/features/auftrag.jpg": [320, 640, 960],
    "/images/vp-starter/features/auftrag.webp": [320, 640, 960],
    "/images/vp-starter/features/erstellung.jpg": [320, 640, 960],
    "/images/vp-starter/features/erstellung.webp": [320, 640, 960],
    "/images/vp-starter/features/features-hero_1x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/features/features-hero_1x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/features/offerten-verwaltung.jpg": [320, 640, 960],
    "/images/vp-starter/features/offerten-verwaltung.webp": [320, 640, 960],
    "/images/vp-starter/features/online-shop.jpg": [320, 640],
    "/images/vp-starter/features/online-shop.webp": [320, 640],
    "/images/vp-starter/features/plattform-systemsteuerung.jpg": [320, 640, 960],
    "/images/vp-starter/features/plattform-systemsteuerung.webp": [320, 640, 960],
    "/images/vp-starter/features/plattform.jpg": [320, 640],
    "/images/vp-starter/features/plattform.webp": [320, 640],
    "/images/vp-starter/features/verwaltung-kontrolle.jpg": [320, 640],
    "/images/vp-starter/features/verwaltung-kontrolle.webp": [320, 640],
    "/images/vp-starter/features/verwaltung.jpg": [320, 640],
    "/images/vp-starter/features/verwaltung.webp": [320, 640],
    "/images/vp-starter/guy-in-cart.jpg": [320, 640],
    "/images/vp-starter/guy-in-cart.webp": [320, 640],
    "/images/vp-starter/guy-with-phone.jpg": [320, 640],
    "/images/vp-starter/guy-with-phone.webp": [320, 640],
    "/images/vp-starter/hero-banners/Beleuchtungsinstallation_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Beleuchtungsinstallation_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Beleuchtungsinstallation_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Beleuchtungsinstallation_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Beratungsdienstleistungen_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Beratungsdienstleistungen_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Beratungsdienstleistungen_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Beratungsdienstleistungen_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Facility-Services_1x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Facility-Services_1x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Facility-Services_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Facility-Services_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Fassadenarbeiten_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Fassadenarbeiten_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Fassadenarbeiten_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Fassadenarbeiten_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gartenpflege_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Gartenpflege_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Gartenpflege_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gartenpflege_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gebaeudetechnik-Service_1x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gebaeudetechnik-Service_1x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gebaeudetechnik-Service_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gebaeudetechnik-Service_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gebäudereinigung_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Gebäudereinigung_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Gebäudereinigung_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Gebäudereinigung_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Heizungsinstallation_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Heizungsinstallation_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Heizungsinstallation_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Heizungsinstallation_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Home_page_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Home_page_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Home_page_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Home_page_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Immobilienverkauf_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Immobilienverkauf_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Immobilienverkauf_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Immobilienverkauf_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Netzwerktechnik_IT-Infrastruktur_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Netzwerktechnik_IT-Infrastruktur_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Netzwerktechnik_IT-Infrastruktur_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Netzwerktechnik_IT-Infrastruktur_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Reinigungsunternehmen_1x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Reinigungsunternehmen_1x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Reinigungsunternehmen_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Reinigungsunternehmen_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Reparaturen_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Reparaturen_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Reparaturen_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Reparaturen_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Sicherheitstechnik_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Sicherheitstechnik_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Sicherheitstechnik_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Sicherheitstechnik_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Spenglerarbeiten_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Spenglerarbeiten_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Spenglerarbeiten_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Spenglerarbeiten_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Starter_1x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Starter_1x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Transportlogistik_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Transportlogistik_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Transportlogistik_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Transportlogistik_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Treuhand-Gesellschaft_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Treuhand-Gesellschaft_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Treuhand-Gesellschaft_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Treuhand-Gesellschaft_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Treuhand-Service_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Treuhand-Service_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Treuhand-Service_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Treuhand-Service_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Verwaltung_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Verwaltung_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Verwaltung_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Verwaltung_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Zahnärzte_1x.jpg": [320, 640],
    "/images/vp-starter/hero-banners/Zahnärzte_1x.webp": [320, 640],
    "/images/vp-starter/hero-banners/Zahnärzte_2x.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/hero-banners/Zahnärzte_2x.webp": [320, 640, 960, 1280],
    "/images/vp-starter/image_2.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/image_2.webp": [320, 640, 960, 1280],
    "/images/vp-starter/image.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/image.webp": [320, 640, 960, 1280],
    "/images/vp-starter/ki-generator-screenshot.jpg": [320, 640, 960, 1280],
    "/images/vp-starter/ki-generator-screenshot.webp": [320, 640, 960, 1280],
    "/images/vp-starter/main-functions/automated-offers.jpg": [320, 640, 960],
    "/images/vp-starter/main-functions/automated-offers.webp": [320, 640, 960],
    "/images/vp-starter/main-functions/distribution-channel.jpg": [320, 640, 960],
    "/images/vp-starter/main-functions/distribution-channel.webp": [320, 640, 960],
    "/images/vp-starter/main-functions/intelligent-prices.jpg": [320, 640, 960],
    "/images/vp-starter/main-functions/intelligent-prices.webp": [320, 640, 960],
    "/images/vp-starter/main-functions/vertrieb-automatisieren.jpg": [320, 640, 960],
    "/images/vp-starter/main-functions/vertrieb-automatisieren.webp": [320, 640, 960],
    "/images/vp-starter/office-guy.jpg": [320],
    "/images/vp-starter/office-guy.webp": [320],
    "/images/vp-starter/social.jpg": [320, 640, 960],
    "/images/vp-starter/social.webp": [320, 640, 960],
    "/images/vp/customers/ewz-logo.jpg": [320, 640, 960, 1280],
    "/images/vp/customers/ewz-logo.webp": [320, 640, 960, 1280],
    "/images/vp/customers/mv.jpg": [320, 640],
    "/images/vp/customers/mv.webp": [320, 640],
    "/images/vp/service-catalog-hero.jpg": [320, 640, 960, 1280],
    "/images/vp/service-catalog-hero.webp": [320, 640, 960, 1280],
    "/images/vp/success-stories/gulenko-quote.jpg": [320, 640],
    "/images/vp/success-stories/gulenko-quote.webp": [320, 640],
    "/images/vp/success-stories/gulenko.jpg": [320, 640],
    "/images/vp/success-stories/gulenko.webp": [320, 640],
    "/images/vp/success-stories/management-tools-quote.webp": [320, 640],
    "/images/vp/success-stories/management-tools.webp": [320, 640],
    "/images/vp/success-stories/stierli-holzbau-quote.webp": [320, 640],
    "/images/vp/success-stories/stierli-holzbau.webp": [320, 640],
    "/images/vpe-hubspot/first_1x.jpg": [320],
    "/images/vpe-hubspot/first_1x.webp": [320],
    "/images/vpe-hubspot/first_2x.jpg": [320],
    "/images/vpe-hubspot/first_2x.webp": [320],
    "/images/vpe-hubspot/fourth_1x.jpg": [320],
    "/images/vpe-hubspot/fourth_1x.webp": [320],
    "/images/vpe-hubspot/fourth_2x.jpg": [320],
    "/images/vpe-hubspot/fourth_2x.webp": [320],
    "/images/vpe-hubspot/HubspotHero_1x.jpg": [320, 640, 960, 1280],
    "/images/vpe-hubspot/HubspotHero_1x.webp": [320, 640, 960, 1280],
    "/images/vpe-hubspot/HubspotHero_2x.jpg": [320, 640, 960, 1280],
    "/images/vpe-hubspot/HubspotHero_2x.webp": [320, 640, 960, 1280],
    "/images/vpe-hubspot/second_1x.jpg": [320],
    "/images/vpe-hubspot/second_1x.webp": [320],
    "/images/vpe-hubspot/second_2x.jpg": [320],
    "/images/vpe-hubspot/second_2x.webp": [320],
    "/images/vpe-hubspot/third_1x.jpg": [320],
    "/images/vpe-hubspot/third_1x.webp": [320],
    "/images/vpe-hubspot/third_2x.jpg": [320],
    "/images/vpe-hubspot/third_2x.webp": [320],
    "/images/whitepaper-scr/hero-scr.jpg": [320, 640, 960],
    "/images/whitepaper-scr/hero-scr.webp": [320, 640, 960],
    "/images/whitepaper-scr/whitepaper-cover.jpg": [320, 640, 960, 1280],
    "/images/whitepaper-scr/whitepaper-cover.webp": [320, 640, 960, 1280],
};
